import React from 'react'
import Style from '../productAttribute.module.css'

/** Attribute name with its data type shown underneath, so the type is always visible. */
const AttributeName = ({ name, dataType }) => (
    <span className={Style.attributeName} title={dataType ? `${name} (${dataType})` : name}>
        <span className={Style.attributeNameText}>{name}</span>
        {dataType ? <span className={Style.attributeType}>{dataType}</span> : null}
    </span>
)

export default AttributeName
